import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;

        & > p {
            ${({ theme }) => theme.font["small-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
    "Title": styled.h2`
        ${({ theme }) => theme.font["large-semibold"]};

        span {
            color: ${({ theme }) => theme.color["error"]};
        }
    `,
    "InputDiv": styled.div`
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 0 12px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.color["grey3"]};
    `,
    "Input": styled.input`
        width: 100%;
        color: ${({ theme }) => theme.color["black"]};
        ${({ theme }) => theme.font["large-medium"]};
    `,
}